import React, { useEffect, useState } from "react";
import Image from "next/image";
import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  LinkedinIcon,
  PinterestIcon,
  TwitterIcon,
  WhatsappIcon,
} from "react-share";
import poster from "../images/radio.webp";
import myicon from "../images/aft3.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

const twitterHash = [
  "online-radio",
  "live-radio",
  "radiostation",
  "music",
  "radio",
  "musicstation",
  "musicradio",
  "jazz",
  "news",
  "sport",
  "entainment",
  "dance",
  "pop",
  "rock",
  "rap",
  "hiphop",
  "rnb",
  "soul",
  "reggae",
  "country",
  "classical",
  "blues",
  "gospel",
  "funk",
  "disco",
  "techno",
  "house",
  "trance",
  "dubstep",
  "electronic",
  "indie",
  "alternative",
];

const ShareInitial = () => {
  const [popupOpen, setPopupOpen] = useState(true);

  const shareLink = "https://radiobruce.com/";

  const description = `Tune in to our live stream featuring 65,000+ free radio stations from around the World. Every genre, no cost - start listening now! Access anywhere, anytime on any device with a browser - no account needed!!`;

  const closePopUp = () => {
    setPopupOpen(!popupOpen);
  };

  useEffect(() => {
    let intervalId = setTimeout(() => {
      setPopupOpen((prev) => !prev);
    }, 90000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <div
      className="initialshare-wrapper"
      style={{ display: !popupOpen ? "flex" : "none" }}
    >
      <div className="initialshare-content">
        <p
          style={{ minWidth: "40px", minHeight: "40px", margin: "0px" }}
          className="closeme"
          onClick={() => closePopUp()}
        >
          <FontAwesomeIcon icon={faTimesCircle} style={{ color: "maroon" }} />
        </p>
        <div style={{ position: "relative", width: "130px", height: "87px" }}>
          {" "}
          <Image priority={true} src={myicon} alt="AFT icon" fill />
        </div>

        <h3>"Spread the love! Help us grow by sharing with your community"</h3>
        <p>"When you share, everyone wins. Let's grow together!"</p>

        <div
          className="social-wrapper"
          style={{
            width: "100%",
            backgroundColor: "#e5e8e5",
            padding: "10px 10px 5px",
            borderRadius: "50px",
          }}
        >
          <FacebookShareButton
            url={shareLink}
            hashtag="#radiobruce"
            aria-label="Center Align"
          >
            <FacebookIcon size={40} round={true} />
          </FacebookShareButton>

          <TwitterShareButton
            url={shareLink}
            hashtag={twitterHash}
            aria-label="Center Align"
          >
            <TwitterIcon size={40} round={true} />
          </TwitterShareButton>

          <WhatsappShareButton
            url={shareLink}
            title="#radiobruce"
            aria-label="Center Align"
          >
            <WhatsappIcon size={40} round={true} />
          </WhatsappShareButton>

          <PinterestShareButton
            url={shareLink}
            media={poster}
            description={description}
            aria-label="Center Align"
          >
            <PinterestIcon size={40} round={true} />
          </PinterestShareButton>

          <LinkedinShareButton
            url={shareLink}
            description={description}
            aria-label="Center Align"
          >
            <LinkedinIcon size={40} round={true} />
          </LinkedinShareButton>
        </div>
      </div>
    </div>
  );
};

export default ShareInitial;
